import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoSpinner = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "29px",
	height: "29px",
	viewBox: "0 0 29 29",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "logo-2",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "logo",
				children: [
					/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						fill: "#CC0000",
						cx: 10.5,
						cy: 2.5,
						r: 2.5,
						children: /* @__PURE__ */ _jsx("animate", {
							attributeName: "fill",
							begin: "0s",
							dur: "1.5s",
							values: "#CC0000;#CCCCCC;#CC0000",
							repeatCount: "indefinite"
						})
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						fill: "#CC0000",
						cx: 10.5,
						cy: 18.5,
						r: 2.5,
						children: /* @__PURE__ */ _jsx("animate", {
							attributeName: "fill",
							begin: "1.5s",
							dur: "1.5s",
							values: "#CC0000;#CCCCCC;#CC0000",
							repeatCount: "indefinite"
						})
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						fill: "#CC0000",
						cx: 18.5,
						cy: 10.5,
						r: 2.5,
						children: /* @__PURE__ */ _jsx("animate", {
							attributeName: "fill",
							begin: "3s",
							dur: "1.5s",
							values: "#CC0000;#CCCCCC;#CC0000",
							repeatCount: "indefinite"
						})
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						fill: "#CC0000",
						cx: 2.5,
						cy: 10.5,
						r: 2.5,
						children: /* @__PURE__ */ _jsx("animate", {
							attributeName: "fill",
							begin: "4.5s",
							dur: "1.5s",
							values: "#CC0000;#CCCCCC;#CC0000",
							repeatCount: "indefinite"
						})
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						fill: "#CC0000",
						cx: 18.5,
						cy: 26.5,
						r: 2.5,
						children: /* @__PURE__ */ _jsx("animate", {
							attributeName: "fill",
							begin: "6s",
							dur: "1.5s",
							values: "#CC0000;#CCCCCC;#CC0000",
							repeatCount: "indefinite"
						})
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						fill: "#CC0000",
						cx: 2.5,
						cy: 26.5,
						r: 2.5,
						children: /* @__PURE__ */ _jsx("animate", {
							attributeName: "fill",
							begin: "7.5s",
							dur: "1.5s",
							values: "#CC0000;#CCCCCC;#CC0000",
							repeatCount: "indefinite"
						})
					})
				]
			})
		})
	})
});
export default SvgLogoSpinner;
